<template>
  <button
    :disabled="disabled"
    :class="[
      finalDisplayStyling +
        finalRoundedStyling +
        finalShadowStyling +
        finalTextSizeStyling +
        finalFontStyling +
        finalTextColorStyling +
        finalPaddingStyling +
        finalBorderStyling +
        finalBackgroundStyling +
        finalBaseFocusStyling +
        finalFocusColorStyling,
      { 'opacity-25': disabled },
    ]"
  >
    <slot name="leadingContent"></slot>
    <slot />
    <slot name="trailingContent"></slot>
  </button>
</template>

<script>
export default {
  name: "UiButton",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    displayStyling: {
      type: String,
      default: "inline-flex items-center",
    },
    roundedStyling: {
      type: String,
      default: "rounded-md",
    },
    shadowStyling: {
      type: String,
      default: "shadow-sm",
    },
    textSizeStyling: {
      type: String,
      default: "text-sm",
    },
    fontStyling: {
      type: String,
      default: "font-medium",
    },
    textColorStyling: {
      type: String,
      default: "text-white",
    },
    paddingStyling: {
      type: String,
      default: "px-4 py-2",
    },
    borderStyling: {
      type: String,
      default: "border border-transparent",
    },
    backgroundStyling: {
      type: String,
      default: "bg-light-blue-600 hover:bg-light-blue-700",
    },
    baseFocusStyling: {
      type: String,
      default: "focus:outline-none focus:ring-2 focus:ring-offset-2",
    },
    focusColorStyling: {
      type: String,
      default: "focus:ring-light-blue-500",
    },
  },
  computed: {
    finalDisplayStyling() {
      return this.classString(this.displayStyling);
    },
    finalRoundedStyling() {
      return this.classString(this.roundedStyling);
    },
    finalShadowStyling() {
      return this.classString(this.shadowStyling);
    },
    finalTextSizeStyling() {
      return this.classString(this.textSizeStyling);
    },
    finalFontStyling() {
      return this.classString(this.fontStyling);
    },
    finalTextColorStyling() {
      return this.classString(this.textColorStyling);
    },
    finalPaddingStyling() {
      return this.classString(this.paddingStyling);
    },
    finalBorderStyling() {
      return this.classString(this.borderStyling);
    },
    finalBackgroundStyling() {
      return this.classString(this.backgroundStyling);
    },
    finalBaseFocusStyling() {
      return this.classString(this.baseFocusStyling);
    },
    finalFocusColorStyling() {
      return this.classString(this.focusColorStyling);
    },
  },
  methods: {
    classString(string) {
      return string + " ";
    },
  },
};
</script>